var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"space-y-2 w-full"},[_c('Tabs',{staticClass:"w-full sm:w-auto",attrs:{"tabs":[{ name: 'Home', routePath: '/' },
    { name: 'Components', routePath: _vm.currentRoute }]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }